import { Component, ElementRef, OnInit, HostListener, ViewChild } from '@angular/core';
import {MenuItem} from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/_services/auth.service';
import { StoreInfo } from 'src/domain/storeInfo';
import { GlobalService } from 'src/app/_services/global.service';
import { Router } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  animations: [
    trigger('openClose', [
      // ...
      state('open', style({
        width: '250px'
      })),
      state('closed', style({
        width: '76px'
      })),
      transition('open => closed', [
        animate('0.2s')
      ]),
      transition('closed => open', [
        animate('0.2s')
      ]),
    ]),
    trigger('openCloseSubitem', [
      transition('open => closed', [
        animate('0.3s')
      ]),
      transition('closed => open', [
        animate('0.3s')
      ]),
    ]),
  ]
})
export class MenuComponent implements OnInit {

  items: MenuItem[];

  @ViewChild('menu') menu: ElementRef;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if(!this.menu.nativeElement.contains(event.target)) {
      this.globalService.openMenu = false;
      for (const menuItem of this.globalService.menuItems) {
        menuItem.expanded = false;
      }
    }
  }

  baseStoreId = this.globalService.selShop;

  storeInfo: StoreInfo;

  loggedUser: any;
  loggedCdC: any;

  loggedSocieta: any;

  constructor(
    private translate: TranslateService, 
    private authService: AuthService, 
    public globalService : GlobalService,
    private router: Router
  ) {
   
  }

  ngOnInit() {
    
  
    this.globalService.openMenu = false;
  
      
  }

  

  public expand(mItem: MenuItem) {
    this.globalService.openMenu = true;
    if (mItem.items && mItem.items.length > 0) {
      for (const menuItem of this.globalService.menuItems) {
     //   if (menuItem != mItem) menuItem.expanded = false;
      }
      mItem.expanded = !mItem.expanded;
    } else {
      if (mItem.routerLink) {
        this.router.navigate([mItem.routerLink]);
        for (const menuItem of this.globalService.menuItems) {
          menuItem.expanded = false;
        }
        this.globalService.openMenu = false;
      }
    }
  }


  // GESTIONE PER MENU
  public expandMenu(mItem: MenuItem) {
    if (mItem.items && mItem.items.length > 0) {
      for (const menuItem of this.globalService.menuItems) {
        if (menuItem != mItem) menuItem.expanded = false;
      }
      mItem.expanded = !mItem.expanded;
    } else {
      if (mItem.routerLink) {
        this.router.navigate([mItem.routerLink]);
      }
    }
  }

  public closeMenu() {
    for (const menuItem of this.globalService.menuItems) {
      menuItem.expanded = false;
    }
  }

}
